// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2JTSo","obliqueLineWrap":"membershipbadge_obliqueLineWrap__nYEbz","obliqueLine":"membershipbadge_obliqueLine__2tvyX"};